import { render } from "./form-item.vue?vue&type=template&id=f54a11b2&scoped=true"
import script from "./form-item.vue?vue&type=script&lang=js"
export * from "./form-item.vue?vue&type=script&lang=js"

import "./form-item.vue?vue&type=style&index=0&id=f54a11b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54a11b2"]])

export default __exports__